var React = require('react');

function ExpandCollapse (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"fillRule":"evenodd","clipRule":"evenodd","key":0}),React.createElement("polygon",{"fillRule":"evenodd","clipRule":"evenodd","key":1})]);
}

ExpandCollapse.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"12px","height":"19px","viewBox":"0 0 12 19","enableBackground":"new 0 0 12 19","xmlSpace":"preserve"};

module.exports = ExpandCollapse;

ExpandCollapse.default = ExpandCollapse;
